import { style, styleVariants } from "@vanilla-extract/css";

const baseStyles = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const badgeWrap = styleVariants({
  small: [baseStyles, { width: "2rem", height: "2rem" }],
  medium: [baseStyles, { width: "4rem", height: "4rem" }],
  large: [baseStyles, { width: "6.8rem", height: "6.8rem" }],
});
